import { useEffect, useRef } from "react";

const useKeyboardNavigation = () => {
  const row = useRef(0);

  const handleKeydown = (e: any) => {
    const navMenu =
      document.querySelector<HTMLDivElement>(".navmenu-container");
    const firstPane = document.querySelector<HTMLDivElement>(
      ".layout-pane:not(.layout-pane-primary)"
    );
    const userMenu =
      document.querySelector<HTMLDivElement>(".app__chats-panel");
    const secondPane = document.querySelector<HTMLDivElement>(
      ".layout-pane-primary"
    );

    const elements = [navMenu, firstPane, secondPane, userMenu].filter(
      (element) => !!element?.offsetHeight && !!element.offsetWidth
    );
    elements.forEach((element) => element?.setAttribute("tabindex", "-1"));

    // TODO: Remove it after some testing. It's not clear why it was added
    // const focusableEls = document.body.querySelectorAll(
    //   'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    // );
    // const firstFocusableEl = focusableEls[0];
    // const lastFocusableEl = focusableEls[focusableEls.length - 1];

    // if (e.shiftKey && e.key === "Tab") {
    //   if (document.activeElement === firstFocusableEl) {
    //     console.log('first');
    //     (lastFocusableEl as HTMLElement).focus();
    //     e.preventDefault();
    //   }
    // } else if (e.key === "Tab") {
    //   if (document.activeElement === lastFocusableEl) {
    //     console.log("last");
    //     (firstFocusableEl as HTMLElement).focus();
    //     e.preventDefault();
    //   }
    // }

    const activeSectionIndex = elements.findIndex((element) =>
      element?.contains(document.activeElement)
    );

    if (
      activeSectionIndex !== -1 &&
      e.ctrlKey &&
      (e.key === "ArrowLeft" || e.key === "ArrowRight")
    ) {
      let nextSectionIndex = 0;
      if (e.key === "ArrowLeft") {
        const index = activeSectionIndex - 1;
        nextSectionIndex = index <= 0 ? elements.length - 1 : index;
      } else {
        const index = activeSectionIndex + 1;
        nextSectionIndex = index >= elements.length - 1 ? 0 : index;
      }
      elements[nextSectionIndex]?.focus();
    }

    if (e.ctrlKey && e.key === "ArrowLeft") {
      e.preventDefault();
      const newRow = row.current - 1;
      if (newRow <= 0) {
        row.current = 0;
      } else {
        row.current = newRow;
      }
    } else if (e.ctrlKey && e.key === "ArrowRight") {
      e.preventDefault();
      const newRow = row.current + 1;
      if (newRow >= elements.length) {
        row.current = elements.length - 1;
      } else {
        row.current = newRow;
      }
    } else {
      return false;
    }

    if (e.ctrlKey && (e.key === "ArrowLeft" || e.key === "ArrowRight")) {
      const element = elements[row.current];
      if (element) {
        // hack to set outline css styles when focus is lost
        element.contentEditable = "true";
        element.focus();
        element.contentEditable = "false";
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown);

    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);
};

export default useKeyboardNavigation;
